// Global portal config
export const USE_SCHEMA_RENDERER = (process.env.REACT_APP_USE_SCHEMA_RENDERER ?? 'true').toLowerCase() !== 'false';

// Auth mode: Cognito only
export const PUBLIC_AUTH_MODE = 'cognito';

// Cognito env (only used when PUBLIC_AUTH_MODE=cognito)
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN; // e.g. https://iset-dev-shared.auth.ca-central-1.amazoncognito.com
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_PORTAL_CLIENT_ID;
export const COGNITO_LOGOUT_REDIRECT_URI = process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI || window.location.origin + '/';
export const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION || 'ca-central-1';
export const AWS_WAF_CAPTCHA_API_KEY = process.env.REACT_APP_WAF_CAPTCHA_API_KEY || '';
export const ENABLE_WAF_CAPTCHA = (process.env.REACT_APP_ENABLE_WAF_CAPTCHA ?? 'true').toLowerCase() !== 'false';

export function buildHostedLogoutUrl() {
	const params = new URLSearchParams({
		client_id: COGNITO_CLIENT_ID,
		logout_uri: COGNITO_LOGOUT_REDIRECT_URI,
	});
	return `${COGNITO_DOMAIN}/logout?${params.toString()}`;
}
